<template>
  <div class="app-container">
    <component :is="currentList" :orders="orders"></component>
  </div>
</template>

<script>
import Available from './components/Available'
import Unavailable from './components/Unavailable'
import { deepClone, parseTime, getTimeval, getUrlParam } from '@/utils'
import { getStopCarInfo, getById } from '@/api/park'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  name: 'Temporary-Parking-Cost',
  components: { Available, Unavailable },
  computed: {
    ...mapGetters(['billParams'])
  },
  data () {
    return {
      currentList: 'Unavailable',
      orders: {},
      config
    }
  },
  created () {
    this.componentsValve()
  },
  methods: {
    componentsValve () {
      let _this = this;
      let getInfo_Loading = _this.$toast.loading('加载中...')
      let id = (this.$route.query.id || getUrlParam('id'))
      let params = {
        cardNumber: _this.billParams.cardNumber || window.decodeURI(_this.$route.query.cardNumber),
        parkId: _this.billParams.parkId || window.decodeURI(_this.$route.query.parkId || -1),
        largeCar: _this.billParams.largeCar || window.decodeURI(_this.$route.query.largeCar || false),
        code: _this.billParams.type || Number(window.decodeURI(_this.$route.query.type || _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType)),
        isMark: _this.$enumObject.providerConfig[config.projectName].otherConfig.parkType,
        id: id ? id : null
      }
      getStopCarInfo(params).then(response => {
        getInfo_Loading.clear()
        let data = response.body
        // 订单详情页面查询参数
        if (data.entranceDate) {
          let exitDate = data.exitDate || parseTime(new Date())
          data.parkingTime = getTimeval(data.entranceDate, exitDate)
          console.log(data.parkingTime)
          if (data.parkingTime == '0天0时0分' && this.config.projectName == 'JNJT') {
            data.parkingTime = '不足1小时'
          }
        }
        if (Object.keys(data).length > 0) {
          _this.orders = deepClone(data)
          _this.currentList = 'Available'
        } else {
          _this.currentList = 'Unavailable'
          if (this.$enumObject.providerConfig[config.projectName].otherConfig.GoBill) {
            this.$router.replace({ name: 'Arrears-Bill-Temporary', query: { cardNumber: params.cardNumber, largeCar: params.largeCar } })
          }
        }
      }).catch(error => {
        getInfo_Loading.clear()
        _this.$notify({
          type: 'danger',
          message: error
        })
      })
    }
  }
}
</script>
